module.exports = __webpack_public_path__ + "img/Salchicha picada.58ab4f31.jpeg";